<script>
import api from '@/command/api'
import DetailFormGroup from '@/components/DetailFormGroup'
import { getAction, postAction, putAction } from '@/command/netTool'
import AddMapLngLat from '@/components/AddMapLngLat'
import { resourceFormConfig } from './config/formConfig'
import apiTool from '@/command/apiTool'
import { getChildren3 } from '@/api/command'

import { Steps, Modal, Input, Form } from 'ant-design-vue'
const Step = Steps.Step
const { TextArea } = Input

export default {
  name: 'resource-detail',
  components: {
    Steps,
    Step,
    Modal,
    Input,
    Form
  },
  data() {
    return {
      ...api.command.getState(),
      detail: {
        sort: 0,
        siteArea: null,
        floorArea: null,
        isZdzy: '1' // 1: 是, 0: 否
      },
      typeList: [],
      landTypeList: [],
      recruitmentTypeList: [],
      jwdAyy: [],
      isViewMode: this.$route.query.type === 'view',
      isAuditMode: this.$route.query.type === 'audit',
      auditLevel: this.$route.query.level || '',
      // 驳回弹窗
      rejectModalVisible: false,
      rejectReason: '',
      rejectForm: new Form.createForm(),
      regionList: []
    }
  },
  mounted() {
    // 获取字典数据
    this.loadDictData()
    this.getRegionData()

    const { id } = this.$route.query
    id &&
      api.command.getDetail
        .call(this, {
          url: `/farmHousingResources/detail?id=${id}`
        })
        .then(res => {
          const { areaCode = '', streetCode = '', villageCode = '' } = res || {}

          this.detail.regionCode = [areaCode, streetCode, villageCode]
          this.detail.dw = `${this.detail.lon}，${this.detail.lat}`
          // 获取审核数据
          if (this.isViewMode || this.isAuditMode) {
            this.loadAuditData(id)
          }
        })
  },

  methods: {
    getRegionData() {
      getAction('/subUser/getAreaTree?parentCode=3302').then(e => {
        this.regionList = getChildren3(e.data)
      })
    },
    getCurrentStep() {
      if (this.auditData.areaUserName) return 2
      if (this.auditData.streetUserName) return 1
      return 0
    },
    // 加载审核数据
    loadAuditData(id) {
      getAction(
        `/farmHousingResources/getAuditData?housingResourcesId=${id}`
      ).then(res => {
        this.auditData = res.data || {}
        this.$forceUpdate()
      })
    },

    // 加载字典数据
    loadDictData() {
      getAction(
        '/admin/dict/codes?codes=housing_resources_type,housing_land_use_nature,recruitment_type',
        {},
        '/bpi'
      ).then(res => {
        if (res.code == 200) {
          // 填充资源类型
          const resourcesTypeList = (
            res.data['housing_resources_type'] || []
          ).map(item => ({
            name: item.name,
            value: item.id
          }))

          // 填充用地性质
          const landUseNatureList = (
            res.data['housing_land_use_nature'] || []
          ).map(item => ({
            name: item.name,
            value: item.id
          }))

          const recruitmentTypeList = (res.data['recruitment_type'] || []).map(
            item => ({
              name: item.name,
              value: item.id
            })
          )

          this.recruitmentTypeList = recruitmentTypeList
          this.typeList = resourcesTypeList
          this.landTypeList = landUseNatureList
        }
      })
    },
    getForm1() {
      const form = resourceFormConfig.getBasicInfo(this.onOpenMap)
      // 修复地理位置的点击事件
      form.data.forEach(item => {
        if (item.key === 'address') {
          item.suffix.onClick = () => this.openMap()
        }
      })
      // 添加下拉列表数据
      form.data.forEach(item => {
        if (item.key === 'resourcesType') {
          item.typeData = this.typeList
        }
        if (item.key === 'landUseNature') {
          item.typeData = this.landTypeList
        }
        if (item.key === 'recruitmentType') {
          item.typeData = this.recruitmentTypeList
        }
        if (item.key === 'regionCode') {
          item.typeData = this.regionList
        }
        // 查看模式下禁用所有字段
        if (this.isViewMode || this.isAuditMode) {
          item.disabled = true
        }
      })
      return form
    },

    openMap() {
      const { showModal } = require('@/command/apiTool')
      showModal({
        title: '定位信息',
        width: 800,
        view: AddMapLngLat,
        viewProps: {
          value: this.detail.address || ''
        },
        success: ({ data }) => {
          if (data) {
            this.detail.address = data
          }
        }
      })
    },
    getFormatRegion(data) {
      let [areaCode = '', streetCode = '', villageCode = ''] = data
      const formatData = {
        areaCode,
        areaName: '',
        streetCode,
        streetName: '',
        villageCode,
        villageName: ''
      }
      let parentArr = this.regionList || []
      ;['areaCode', 'streetCode', 'villageCode'].forEach(item => {
        if (!parentArr || parentArr.length === 0) return
        const value = formatData[item] || ''
        let currentIndex = parentArr.findIndex(e => e.value === value)

        if (!value) {
          currentIndex = 0
        }
        formatData[`${item}`] = parentArr[currentIndex].areaCode || ''
        formatData[`${item.replace('Code', 'Name')}`] =
          parentArr[currentIndex].areaName || ''

        parentArr = parentArr[currentIndex]?.children
      })

      return formatData
    },
    onOpenMap() {
      apiTool.openMap({
        title: '打开地图',
        value: this.jwdAyy,
        onSuccess: data => {
          this.detail.lat = data.lat
          this.detail.lon = data.lng
          this.detail.dw = `${this.detail.lon}，${this.detail.lat}`
          getAction('/api/gao', {
            location: `${this.detail.lon},${this.detail.lat}`
          }).then(res => {
            let { address, codes } = res.data
            this.detail.areaCode = codes
            this.detail.address = address
            this.$forceUpdate()
          })
          let obj = {
            lng: data.lng,
            lat: data.lat,
            id: data.id
          }
          this.jwdAyy = [obj]
          this.$forceUpdate()
        }
      })
    },

    getFoot() {
      // 查看模式下只显示取消按钮
      if (this.isViewMode) {
        return {
          left: [
            {
              name: '返回',
              type: 'default',
              onClick: () => {
                setTimeout(() => {
                  this.$router.back()
                }, 500)
              }
            }
          ]
        }
      }

      // 审核模式下显示审核按钮
      if (this.isAuditMode) {
        return {
          left: [
            {
              name: '审核通过',
              type: 'primary',
              onClick: () => {
                this.handleAuditPass()
              }
            },
            {
              name: '驳回',
              type: 'danger',
              onClick: () => {
                this.handleAuditReject()
              }
            },
            {
              name: '取消',
              type: 'default',
              onClick: () => {
                setTimeout(() => {
                  this.$router.back()
                }, 500)
              }
            }
          ]
        }
      }

      const left = [
        {
          name: '提交',
          type: 'primary',
          loading: this.loading,
          sumbit: true,
          onClick: async data => {
            // 为resourcesTypeLabel和landUseNatureLabel赋值
            if (data.resourcesType) {
              const resourcesTypeItem = this.typeList.find(
                item => item.value === data.resourcesType
              )
              if (resourcesTypeItem) {
                data.resourcesTypeLabel = resourcesTypeItem.name
              }
            }
            if (data.landUseNature) {
              const landUseNatureItem = this.landTypeList.find(
                item => item.value === data.landUseNature
              )
              if (landUseNatureItem) {
                data.landUseNatureLabel = landUseNatureItem.name
              }
            }

            if (data.recruitmentType) {
              const recruitmentTypeItem = this.recruitmentTypeList.find(
                item => item.value === data.recruitmentType
              )
              if (recruitmentTypeItem) {
                data.recruitmentTypeLabel = recruitmentTypeItem.name
              }
            }
            let regionParams = {}
            if (data.regionCode) {
              regionParams = this.getFormatRegion(data.regionCode)
            }
            data = {
              ...data,
              ...regionParams
            }

            if (this.detail.id) {
              // 编辑
              await putAction('/farmHousingResources/update', data).then(
                res => {
                  if (res.code == 200) {
                    this.$message.success('编辑成功')
                    this.$router.back()
                  } else {
                    this.$message.error(res.msg || '编辑失败')
                  }
                }
              )
            } else {
              // 新增
              await postAction('/farmHousingResources/save', data).then(res => {
                if (res.code == 200) {
                  this.$message.success('新增成功')
                  this.$router.back()
                } else {
                  this.$message.error(res.msg || '新增失败')
                }
              })
            }
          }
        },
        {
          name: '取消',
          type: 'default',
          onClick: () => {
            setTimeout(() => {
              this.$router.back()
            }, 500)
          }
        }
      ]
      const right = []
      return {
        left,
        right: this.detail.id && right
      }
    },

    // 审核通过
    handleAuditPass() {
      // 二次确认弹窗
      Modal.confirm({
        title: '确认审核通过',
        content: '确定要审核通过该资源吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          const { id } = this.$route.query
          if (this.auditLevel === 'town') {
            // 乡镇级审核
            postAction('/farmHousingResourcesStreetAudit/audit', {
              id: id,
              status: 0 // 0: 通过
            }).then(res => {
              if (res.code == 200) {
                this.$message.success('审核通过')
                this.$router.back()
              } else {
                this.$message.error(res.msg || '审核失败')
              }
            })
          } else {
            // 区级别审核
            postAction('/farmHousingResourcesAreaAudit/audit', {
              id: id,
              status: 0 // 0: 通过
            }).then(res => {
              if (res.code == 200) {
                this.$message.success('审核通过')
                this.$router.back()
              } else {
                this.$message.error(res.msg || '审核失败')
              }
            })
          }
        }
      })
    },

    // 审核驳回
    handleAuditReject() {
      // 打开驳回弹窗
      this.rejectModalVisible = true
    },

    // 确认驳回
    handleRejectConfirm() {
      const { id } = this.$route.query
      if (this.auditLevel === 'town') {
        // 乡镇级审核
        postAction('/farmHousingResourcesStreetAudit/audit', {
          id: id,
          status: 1, // 1: 驳回
          remark: this.rejectReason
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('已驳回')
            this.rejectModalVisible = false
            this.rejectReason = ''
            this.$router.back()
          } else {
            this.$message.error(res.msg || '操作失败')
          }
        })
      } else {
        // 区级别审核
        postAction('/farmHousingResourcesAreaAudit/audit', {
          id: id,
          status: 1, // 1: 驳回
          remark: this.rejectReason
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('已驳回')
            this.rejectModalVisible = false
            this.rejectReason = ''
            this.$router.back()
          } else {
            this.$message.error(res.msg || '操作失败')
          }
        })
      }
    },

    // 取消驳回
    handleRejectCancel() {
      this.rejectModalVisible = false
      this.rejectReason = ''
    }
  },
  render() {
    const showAuditFlow = this.isViewMode || this.isAuditMode
    console.log(
      'showAuditFlow:',
      showAuditFlow,
      'isViewMode:',
      this.isViewMode,
      'isAuditMode:',
      this.isAuditMode
    )

    return (
      <div class="resource-detail-container">
        {showAuditFlow && (
          <div class="audit-flow">
            <a-steps
              current={this.getCurrentStep()}
              progress-dot
              style="width: 100%;"
            >
              <a-step
                title="提交"
                description={
                  <div class="step-desc">
                    <div>提交人：{this.auditData.submitUserName || '暂无'}</div>
                    <div>提交时间：{this.auditData.submitTime || '暂无'}</div>
                  </div>
                }
              />
              <a-step
                title="乡镇级审核"
                description={
                  <div class="step-desc">
                    <div>
                      乡镇管理员（审核人）：
                      {this.auditData.streetUserName || '暂无'}
                    </div>
                    <div>提交时间：{this.auditData.streetTime || '暂无'}</div>
                  </div>
                }
              />
              <a-step
                title="区级审核"
                description={
                  <div class="step-desc">
                    <div>
                      区级管理员（审核人）：
                      {this.auditData.areaUserName || '暂无'}
                    </div>
                    <div>提交时间：{this.auditData.areaTime || '暂无'}</div>
                  </div>
                }
              />
            </a-steps>
          </div>
        )}
        <DetailFormGroup
          form={this.detail}
          foot={this.getFoot()}
          data={[this.getForm1()]}
          disabled={this.isViewMode}
        />
        {/* 驳回弹窗 */}
        <Modal
          v-model={this.rejectModalVisible}
          title="驳回原因"
          width="500px"
          onOk={this.handleRejectConfirm}
          onCancel={this.handleRejectCancel}
        >
          <div style={{ margin: '0 0 20px' }}>
            <TextArea
              v-model={this.rejectReason}
              placeholder="请输入驳回原因"
              rows={4}
              style={{ width: '100%' }}
            />
          </div>
        </Modal>
      </div>
    )
  }
}
</script>
<style lang="less" scoped>
.entityInformation-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
  padding-bottom: 70px;
}

.resource-detail-container {
  .audit-flow {
    padding: 30px 70px;
    margin-bottom: 20px;
    background: #fff;
    border-radius: 4px;

    .step-desc {
      font-size: 12px;
      color: #666;
      line-height: 1.8;
      margin-top: 8px;

      div {
        margin-bottom: 4px;
        white-space: nowrap;
      }
    }
  }
}
</style>
